var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TextField } from '@material-ui/core';
import React from 'react';
import { buildInputIcon } from './text-input-icon';
import { numberInputFieldStyles } from './text-input-styles';
var TextInput = function (_a) {
    var onChange = _a.onChange, value = _a.value, inputColor = _a.inputColor, _b = _a.color, color = _b === void 0 ? 'secondary' : _b, inputIcon = _a.inputIcon, InputProps = _a.InputProps, FormHelperTextProps = _a.FormHelperTextProps, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, rest = __rest(_a, ["onChange", "value", "inputColor", "color", "inputIcon", "InputProps", "FormHelperTextProps", "fullWidth"]);
    var classes = numberInputFieldStyles({ color: inputColor || color });
    var inputIconProps = inputIcon ? buildInputIcon(inputIcon) : {};
    return (React.createElement(TextField, __assign({ value: value, classes: { root: classes.inputRoot }, onChange: onChange, fullWidth: fullWidth, FormHelperTextProps: __assign({ classes: { root: classes.helper } }, FormHelperTextProps), InputProps: __assign(__assign({}, inputIconProps), InputProps) }, rest)));
};
export default TextInput;
